var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsBoolean, IsDefined, IsIn, IsInt, IsOptional, IsString, IsUUID, Max, Min, MinLength, } from "class-validator";
import { plainToInstance } from "class-transformer";
import { DEPARTMENT_LIST } from "../../constants";
import { BaseDTO } from "./BaseDTO";
import { ExposeFrontend } from "../../decorators";
export class NewReviewBase {
}
__decorate([
    IsDefined()
], NewReviewBase.prototype, "gradeLevel", void 0);
__decorate([
    IsDefined()
], NewReviewBase.prototype, "grade", void 0);
__decorate([
    IsDefined()
], NewReviewBase.prototype, "courseType", void 0);
__decorate([
    IsInt(),
    Min(100),
    Max(599)
], NewReviewBase.prototype, "courseNum", void 0);
__decorate([
    IsIn(DEPARTMENT_LIST)
], NewReviewBase.prototype, "department", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4)
], NewReviewBase.prototype, "overallRating", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4)
], NewReviewBase.prototype, "presentsMaterialClearly", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4)
], NewReviewBase.prototype, "recognizesStudentDifficulties", void 0);
__decorate([
    MinLength(20)
], NewReviewBase.prototype, "rating", void 0);
export class AddReviewRequest extends NewReviewBase {
}
__decorate([
    IsUUID()
], AddReviewRequest.prototype, "professor", void 0);
export class AddReviewResponse extends BaseDTO {
    static new(success, statusMessage, newReviewId) {
        return plainToInstance(AddReviewResponse, { success, statusMessage, newReviewId });
    }
}
__decorate([
    ExposeFrontend(),
    IsBoolean()
], AddReviewResponse.prototype, "success", void 0);
__decorate([
    ExposeFrontend(),
    IsString()
], AddReviewResponse.prototype, "statusMessage", void 0);
__decorate([
    IsOptional(),
    IsString(),
    ExposeFrontend()
], AddReviewResponse.prototype, "newReviewId", void 0);
//# sourceMappingURL=AddReview.js.map